import { type Step, type Tour } from 'nextstepjs'

import { Device } from '#/shared/lib/types/entities'

export const tourStepsDesktop: Tour[] = [
	{
		tour: 'text-models',
		steps: [
			{
				icon: '',
				title: 'Давайте начнем! 🚀',
				content: 'Здесь вы сможете найти ChatGPT и её различные версии, а также LLaMA и Mistral и другие. Выберем одну из них для начала работы.',
				selector: '#text-models-tour-1',
				side: 'right',
				showControls: true,
				nextRoute: '/chat-bot/chatgpt',
				showSkip: true,
			},
			{
				icon: '',
				title: 'Выбор версии модели',
				content: 'В этом блоке вы можете выбрать интересующую вас версию модели',
				selector: '#text-models-tour-3',
				side: 'left',
				showControls: true,
				showSkip: true,
			},
			{
				icon: '',
				title: 'Введите свой первый запрос',
				content: 'Используйте это поле для ввода вашего запроса, а затем кликните на кнопку отправки.',
				selector: '#text-models-tour-2',
				side: 'top',
				showControls: true,
				showSkip: true,
				nextButtonText: 'Напиши за меня →',
				suggestedQuery: 'Опиши кратко, что такое искусственный интеллект и как он применяется в повседневной жизни',
			} as Step,
			{
				icon: '',
				title: 'Отправить запрос',
				content: 'Нажмите на кнопку, чтобы отправить ваш запрос.',
				selector: '#text-models-tour-4',
				side: 'top',
				showSkip: true,
				sendMessageOnClick: true,
			} as Step,
		],
	},
	{
		tour: 'images',
		steps: [
			{
				icon: '',
				title: 'Множество популярных моделей! 🖼️',
				content: 'Здесь представлены мощные модели для генерации изображений: Flux, Stable Diffusion, Midjourney, DALL-E и другие. Выберем одну из них для начала работы.',
				selector: '#images-models-tour-1',
				nextRoute: '/images/flux',
				side: 'top',
				showControls: true,
				showSkip: true,
			},
			{
				icon: '',
				title: 'Параметры генерации',
				content: 'В этом блоке вы можете корректировать параметры генерации изображения',
				selector: '#images-models-tour-3',
				side: 'left',
				showControls: true,
				showSkip: true,
			},
			{
				icon: '',
				title: 'Ввод запроса',
				content: 'Используйте это поле для ввода вашего запроса, а затем кликните на кнопку отправки.',
				selector: '#images-models-tour-2',
				side: 'top',
				showControls: true,
				showSkip: true,
				nextButtonText: 'Напиши за меня →',
				suggestedQuery: 'Кот в космическом скафандре на фоне звёзд',
			} as Step,
			{
				icon: '',
				title: 'Отправить запрос',
				content: 'Нажмите на кнопку, чтобы отправить ваш запрос.',
				selector: '#text-models-tour-4',
				side: 'top',
				showSkip: true,
				sendMessageOnClick: true,
			} as Step,
		],
	},
]

export const tourStepsMobile: Tour[] = [
	{
		tour: 'text-models',
		steps: [
			{
				icon: '',
				title: 'Давайте начнем! 🚀',
				content: 'Здесь вы сможете найти ChatGPT и её различные версии, а также LLaMA и Mistral и другие. Выберем одну из них для начала работы.',
				selector: '#text-models-tour-1',
				side: 'bottom',
				showControls: true,
				nextRoute: '/chat-bot/chatgpt',
				showSkip: true,
			},
			{
				icon: '',
				title: 'Введите свой первый запрос',
				content: 'Используйте это поле для ввода вашего запроса, а затем кликните на кнопку отправки.',
				selector: '#text-models-tour-2',
				side: 'top',
				showControls: true,
				showSkip: true,
				nextButtonText: 'Напиши за меня →',
				suggestedQuery: 'Опиши кратко, что такое искусственный интеллект и как он применяется в повседневной жизни',
			} as Step,
			{
				icon: '',
				title: 'Отправить запрос',
				content: 'Нажмите на кнопку, чтобы отправить ваш запрос.',
				selector: '#text-models-tour-2',
				side: 'left',
				showSkip: true,
				sendMessageOnClick: true,
			} as Step,
		],
	},
	{
		tour: 'images',
		steps: [
			{
				icon: '',
				title: 'Множество популярных моделей! 🖼️',
				content: 'Здесь представлены мощные модели для генерации изображений: Flux, Stable Diffusion, Midjourney, DALL-E и другие. Выберем одну из них для начала работы.',
				selector: '#images-models-tour-1',
				nextRoute: '/images/flux',
				side: 'bottom',
				showControls: true,
				showSkip: true,
			},
			{
				icon: '',
				title: 'Ввод запроса',
				content: 'Используйте это поле для ввода вашего запроса, а затем кликните на кнопку отправки.',
				selector: '#images-models-tour-2',
				side: 'top',
				showControls: true,
				showSkip: true,
				nextButtonText: 'Напиши за меня →',
				suggestedQuery: 'Кот в космическом скафандре на фоне звёзд',
			} as Step,
			{
				icon: '',
				title: 'Отправить запрос',
				content: 'Нажмите на кнопку, чтобы отправить ваш запрос.',
				selector: '#images-models-tour-2',
				side: 'top',
				showSkip: true,
				sendMessageOnClick: true,
			} as Step,
		],
	},
]

export const getTourSteps = (device: Device): Tour[] => {
	return device === 'mobile' ? tourStepsMobile : tourStepsDesktop
}

// Для обратной совместимости (по умолчанию desktop)
export const tourSteps = tourStepsDesktop

export type TourName = 'text-models' | 'images'

